import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServices = async (ids, salonId) => {
  if (!ids || ids === 'all' || !salonId) return null;

  const serviceIds = Array.isArray(ids) ? ids : [ids];

  // First get teams from the specific salon
  const { data: salonTeams, error: salonError } = await supabase
    .from('teams')
    .select('id')
    .eq('salon', salonId);

  if (salonError) {
    throw new Error(salonError.message);
  }

  const salonTeamIds = salonTeams.map(team => team.id);

  // Then get the service-team relationships
  const { data: team, error: teamError } = await supabase
    .from('services_teams')
    .select(`
      *,
      teams(*)
    `)
    .in('service', serviceIds)
    .in('teams', salonTeamIds);

  if (teamError) {
    throw new Error(teamError.message);
  }

  return team;
}

export default function useGetServicesTeamsByServiceIdConvert(ids, salonId) {
  const enabled = !!ids && ids !== 'all' && !!salonId;

  return useQuery({
    queryKey: ['useGetServicesTeamsByServiceId', ids, salonId],
    queryFn: () => getServices(ids, salonId),
    staleTime: 0,
    enabled: enabled
  });
}